import React, { useState } from "react";
import { FaTimes, FaChevronDown, FaChevronUp, FaChevronLeft, FaChevronRight } from "react-icons/fa";

// === DATOS DE EJEMPLO CON 7 ELEMENTOS ===
const VERSION_DATA = [
  {
    version: "v5.0.0 - El Gran Rediseño Final",
    date: "10 de Julio, 2026",
    description:
      "Una reestructuración completa del sistema enfocada en el trabajo en equipo y la modernización de la interfaz.",
    changes: [
      {
        module: "Tareas",
        type: "NUEVO",
        label: "success",
        text: "Funcionalidad de colaboración en tiempo real para editar tareas con otros usuarios simultáneamente.",
      },
      {
        module: "UI/UX",
        type: "CAMBIO",
        label: "primary",
        text: "Rediseño completo de la interfaz de usuario con una nueva paleta de colores y mejor accesibilidad.",
      },
      {
        module: "Core",
        type: "OBSOLETO",
        label: "warning",
        text: "Se eliminó el soporte para navegadores antiguos (Internet Explorer 11).",
      },
    ],
  },
  {
    version: "v5.2.1 - Actualización de Integraciones",
    date: "28 de Mayo, 2026",
    description:
      "Conectando tu espacio de trabajo con las herramientas que ya utilizas todos los días.",
    changes: [
      {
        module: "Calendar",
        type: "AÑADIDO",
        label: "success",
        text: "Sincronización bidireccional automática con Google Calendar y Microsoft Outlook.",
      },
      {
        module: "Ajustes",
        type: "AÑADIDO",
        label: "success",
        text: "Soporte completo para tres nuevos idiomas: Español, Francés y Alemán.",
      },
      {
        module: "Mobile",
        type: "CORREGIDO",
        label: "danger",
        text: "Los botones de eliminar ya no se superponen con el texto en pantallas de dispositivos móviles pequeños.",
      },
    ],
  },
  {
    version: "v5.1.0 - Mejoras de Rendimiento",
    date: "03 de Marzo, 2026",
    description:
      "Actualización enfocada en la calidad de vida de nuestros usuarios y la velocidad de la aplicación.",
    changes: [
      {
        module: "Apariencia",
        type: "AÑADIDO",
        label: "success",
        text: "Modo oscuro (Dark Mode) disponible en toda la interfaz, configurable desde los ajustes.",
      },
      {
        module: "Base de Datos",
        type: "MEJORA",
        label: "primary",
        text: "Optimización de la base de datos: el tiempo de carga de los tableros se redujo en un 40%.",
      },
      {
        module: "Autenticación",
        type: "CORREGIDO",
        label: "danger",
        text: "Se solucionó un error crítico que impedía restablecer la contraseña al usar navegadores como Safari iOS.",
      },
    ],
  },
  {
    version: "v4.0.0 - El Gran Rediseño I",
    date: "10 de Julio, 2026",
    description: "Una reestructuración completa del sistema.",
    changes: [
      { module: "Tareas", type: "NUEVO", label: "success", text: "Colaboración en tiempo real." },
    ],
  },
  {
    version: "v4.2.1 - Integraciones",
    date: "28 de Mayo, 2026",
    description: "Conexión con herramientas externas.",
    changes: [
      { module: "Calendar", type: "AÑADIDO", label: "success", text: "Sincronización con Google Calendar." },
    ],
  },
  {
    version: "v3.1.0 - Mejoras de Rendimiento Beta",
    date: "03 de Marzo, 2026",
    description: "Optimización de velocidad.",
    changes: [
      { module: "Apariencia", type: "AÑADIDO", label: "success", text: "Modo oscuro." },
    ],
  },
  {
    version: "v2.0.4 - Corrección de BUGS",
    date: "15 de Febrero, 2026",
    description: "Parches menores de seguridad.",
    changes: [
      { module: "Core", type: "CORREGIDO", label: "danger", text: "Solución a fuga de memoria." },
    ],
  },
  {
    version: "v2.0.2 - Parche de UI",
    date: "01 de Febrero, 2026",
    description: "Ajustes estéticos.",
    changes: [
      { module: "UI/UX", type: "CAMBIO", label: "primary", text: "Ajuste de márgenes globales." },
    ],
  },
  {
    version: "v2.0.1 - Primera Actualización",
    date: "20 de Enero, 2026",
    description: "Primeros ajustes post-lanzamiento.",
    changes: [
      { module: "Ajustes", type: "MEJORA", label: "primary", text: "Mejora en la carga de perfil." },
    ],
  },
  {
    version: "v2.0.0 - Lanzamiento Oficial",
    date: "01 de Enero, 2026",
    description: "Primera versión pública.",
    changes: [
      { module: "Core", type: "NUEVO", label: "success", text: "Lanzamiento inicial." },
    ],
  },
];

const getBadgeClass = (label) => {
  if (label === "warning")
    return "bg-warning-subtle text-warning-emphasis border border-warning-subtle";
  return `bg-${label}-subtle text-${label} border border-${label}-subtle`;
};

function VersionModal({ isOpen, onClose }) {
  const [openVersions, setOpenVersions] = useState({ 0: true });
  const [currentPage, setCurrentPage] = useState(1);
  
  // Muestra 5 versiones por página
  const itemsPerPage = 5; 

  if (!isOpen) return null;

  const toggleVersion = (index) => {
    setOpenVersions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Paginación: totalPages solo será mayor a 1 cuando VERSION_DATA tenga más de 5 elementos
  const totalPages = Math.ceil(VERSION_DATA.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentVersions = VERSION_DATA.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      onClick={onClose}
      style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", zIndex: 1100 }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "95%" }}
      >
        <div
          className="modal-content border-0 p-4 position-relative"
          style={{ borderRadius: "8px" }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="border-0 bg-transparent position-absolute"
            onClick={onClose}
            style={{
              top: "20px",
              right: "20px",
              fontSize: "1.2rem",
              color: "#6c757d",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            <FaTimes />
          </button>

          <div className="modal-body pt-2 text-start">
            <div className="text-center mb-4">
              <h2 className="fw-bold mb-1" style={{ color: "#002454" }}>
                Historial de Actualizaciones
              </h2>
              <p className="text-muted fs-6">
                Descubre las últimas novedades y mejoras de nuestra plataforma.
              </p>
            </div>

            <div
              className="updates-list"
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                paddingRight: "10px",
              }}
            >
              {currentVersions.map((item, index) => {
                const globalIndex = startIndex + index;
                const isOpenVersion = !!openVersions[globalIndex];

                return (
                  <div
                    key={globalIndex}
                    className="card border-0 p-4 bg-light mb-4"
                    style={{
                      borderRadius: "6px",
                      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center flex-wrap"
                      onClick={() => toggleVersion(globalIndex)}
                      style={{ cursor: "pointer" }}
                    >
                      <h5
                        className="fw-bold m-0"
                        style={{ color: "#0056b3", fontSize: "1.4rem" }}
                      >
                        {item.version}
                      </h5>
                      <div className="d-flex align-items-center gap-3">
                        <span className="text-muted small">{item.date}</span>
                        <button className="btn btn-sm text-secondary border-0 p-0">
                          {isOpenVersion ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>
                    </div>

                    {isOpenVersion && (
                      <div className="mt-3">
                        <hr className="text-muted my-3" />
                        <p className="text-secondary fs-6 mb-4">
                          {item.description}
                        </p>
                        <div className="d-flex flex-column gap-3">
                          {item.changes.map((change, cIndex) => (
                            <div
                              key={cIndex}
                              className="d-flex align-items-start gap-3 flex-wrap"
                            >
                              {change.module && (
                                <span
                                  className="badge bg-secondary-subtle text-secondary border border-secondary-subtle px-2 py-1"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {change.module}
                                </span>
                              )}
                              <span
                                className={`badge px-2 py-1 ${getBadgeClass(
                                  change.label
                                )}`}
                                style={{
                                  minWidth: "100px",
                                  textAlign: "center",
                                }}
                              >
                                {change.type}
                              </span>
                              <span className="text-dark fs-6 flex-grow-1">
                                {change.text}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* APARECE ÚNICAMENTE SI HAY MÁS DE 5 ELEMENTOS (totalPages > 1) */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center my-3 pt-2 border-top">
                <button
                  className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                >
                  <FaChevronLeft /> Anterior
                </button>
                <span className="text-muted small">
                  Página {currentPage} de {totalPages}
                </span>
                <button
                  className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Siguiente <FaChevronRight />
                </button>
              </div>
            )}

            <div className="text-center mt-4">
              <button
                type="button"
                className="btn text-white fw-bold px-5 py-2"
                onClick={onClose}
                style={{
                  backgroundColor: "#e6006f",
                  borderRadius: "4px",
                  border: "none",
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VersionModal;